const HIGHCHARTS_DEFAULT_COLORS = [
	'#2caffe',
	'#544fc5',
	'#00e272',
	'#fe6a35',
	'#6b8abc',
	'#d568fb',
	'#2ee0ca',
	'#fa4b42',
	'#feb56a',
	'#91e8e1',
];
export const getColorsByIndex = (index: number) => {
	return HIGHCHARTS_DEFAULT_COLORS[index % HIGHCHARTS_DEFAULT_COLORS.length];
};

export const resolveColorForItems = <T>(items: T[]): (T & { color: string })[] => {
	const resolvedItems: (T & { color: string })[] = [];

	let colorIndex = 0;
	for (const item of items) {
		if (colorIndex > HIGHCHARTS_DEFAULT_COLORS.length - 1) {
			colorIndex = 0;
		}
		resolvedItems.push({
			...item,
			color: HIGHCHARTS_DEFAULT_COLORS[colorIndex],
		});

		colorIndex++;
	}
	return resolvedItems;
};
